/* eslint-disable max-lines-per-function */
import React from "react";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { Button, Grid } from "@mui/material";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";
import { Modal } from "components/haven-design";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { ListBuildingUnits_buildingUnits as BuildingUnitType } from "types/gql-types";
import UnitFormSharedFields, { BuildingUnitSharedType, sharedFieldsValidations } from "./unit-form-shared-fields";

const toggleInitialValues = {
  bedrooms: false,
  bathrooms: false,
  occupancy: false,
  rent: false,
  sqft: false,
  floor: false,
  occupied: false,
  accessibility: false,
  referral: false,
  incomeDesignation: false,
  fundingSource: false,
  preference: false,
};

export type ToggleSwitches = typeof toggleInitialValues;

const initialValues: BuildingUnitSharedType & {toggle: ToggleSwitches} = {
  bedrooms: "",
  bathrooms: 0,
  occupancyMin: 1,
  occupancyMax: 1,
  rentType: "fixed",
  rentValue: 0,
  sqft: 0,
  floor: 0,
  occupied: "Vacant",
  isReferral: false,
  referralOrg: "",
  accessibility: [],
  toggle: toggleInitialValues,
  fundingSource: [],
  incomeDesignation: "none",
  preference: [],
};

const validationSchema = yup.object().shape({
  ...sharedFieldsValidations,
});

type Props = {
  isOpen: boolean,
  closeModal: () => void,
  items: BuildingUnitType[]
  handleBatchUpdateUnit: (items: BuildingUnitType[],
    sharedValues: Partial<BuildingUnitType>, toggleSwitches: ToggleSwitches) => void,
}
const BatchUnitEditForm: React.FC<Props> =
({ isOpen, closeModal, items, handleBatchUpdateUnit }) => (
  <Modal
    onRequestClose={closeModal}
    isOpen={isOpen}
    title={items.length === 1 ? "Edit Unit" : "Batch Edit Units"}
    fullScreen
  >
    <Formik
      initialValues={{ ...initialValues, ...items[0] }}
      validationSchema={validationSchema}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSubmit={({ toggle, ...sharedValues }, { resetForm }) => {
        handleBatchUpdateUnit(items, sharedValues, toggle);
        resetForm();
        closeModal();
      }}
    >
      {({ isSubmitting }) => (<>
        <DialogContent>
          <Form id="batch-edit-units">
            <Grid container spacing={2}>
              {items.length === 1 && (
                <Grid size={{ xs: 12 }}>
                  <Input margin="none" label="Unit Name" name="name" />
                </Grid>
              )}
              <UnitFormSharedFields toggleUpdate={items.length !== 1} />
            </Grid>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={closeModal}>Cancel</Button>
          <Button
            form="batch-edit-units"
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting}
          >
            Update {items.length === 1 ? " Unit" : ` (${items.length}) Units`}
          </Button>

        </DialogActions>
      </>
      )}
    </Formik>
  </Modal>
);

export default BatchUnitEditForm;
